import type { ArtworkRecord, SearchDocument, SearchRequest, SearchResponse } from '../../contracts/src/search.js';
import type { VectorEntry } from '../../vector-engine/src/index.js';
import { HybridSearchEngine } from './hybrid-search-engine.js';

export class LocalSearchEngine {
  readonly #engine: HybridSearchEngine;

  constructor(items: readonly ArtworkRecord[]) {
    const entries: readonly VectorEntry[] = items.map((item) => ({ id: item.id, vector: Float32Array.from(item.vector) }));
    this.#engine = new HybridSearchEngine(entries, items.map(toSearchDocument));
  }

  search(request: SearchRequest): SearchResponse {
    return this.#engine.search(request);
  }
}

export function toSearchDocument(item: ArtworkRecord): SearchDocument {
  return {
    id: item.id,
    year: item.year,
    clusterId: item.clusterId,
    title: item.title,
    tags: item.tags,
    objectName: item.objectName,
    classification: item.classification,
    medium: item.medium,
    department: item.department,
    culture: item.culture,
    period: item.period,
    creator: item.creator
  };
}
